/** Romanian — the primary (and currently only) locale. */
export const ro = {
  translation: {
    app: {
      name: 'Gral Medical',
    },
    auth: {
      login: {
        title: 'Conectați-vă la contul dvs.',
        subtitle: 'Folosiți-vă e-mailul pentru a vă conecta.',
        email: 'Email',
        email_placeholder: 'nume@exemplu.ro',
        password: 'Parolă',
        password_placeholder: 'Parola dvs.',
        submit: 'Autentificare',
        forgot: 'Ai uitat parola?',
        no_account: 'Nu ai cont?',
        create_account: 'Creează cont',
        or: 'sau continuă cu',
        show_password: 'Arată parola',
        hide_password: 'Ascunde parola',
      },
      social: {
        google: 'Continuă cu Google',
        facebook: 'Continuă cu Facebook',
        apple: 'Continuă cu Apple',
        unavailable: 'Autentificarea socială va fi disponibilă în curând.',
      },
    },
    validation: {
      email_required: 'Adresa de email este obligatorie.',
      email_invalid: 'Introduceți o adresă de email validă.',
      password_required: 'Parola este obligatorie.',
      password_min: 'Parola trebuie să aibă cel puțin 8 caractere.',
      password_confirm_required: 'Confirmați parola.',
      passwords_mismatch: 'Parolele nu coincid.',
      first_name_required: 'Numele este obligatoriu.',
      last_name_required: 'Prenumele este obligatoriu.',
      phone_invalid: 'Introduceți un număr de telefon valid.',
      terms_required: 'Trebuie să acceptați termenii și condițiile.',
      otp_invalid: 'Introduceți codul primit pe email.',
    },
    register: {
      title: 'Creează cont',
      subtitle: 'Completați datele pentru a vă crea un cont.',
      otp_subtitle: 'Verificați-vă adresa de email.',
      nume: 'Nume',
      prenume: 'Prenume',
      phone: 'Telefon',
      confirm_password: 'Confirmă parola',
      terms: 'Sunt de acord cu termenii și condițiile și politica de confidențialitate.',
      submit: 'Creează cont',
      have_account: 'Ai deja cont?',
      otp_sent: 'Am trimis un cod de verificare la {{email}}.',
      otp: 'Cod de verificare',
      verify: 'Verifică',
      resend: 'Retrimite codul',
      otp_resent: 'Codul a fost retrimis.',
      done_title: 'Cont creat cu succes!',
      done_hint:
        'Autentifică-te cu emailul și parola ta. La prima autentificare vei primi pe email un cod de verificare a contului.',
      go_login: 'Mergi la autentificare',
    },
    verify_email: {
      title: 'Verifică-ți adresa de email',
      subtitle: 'Introdu codul primit pe email pentru a continua.',
      logout: 'Ieși din cont',
    },
    errors: {
      network: 'A apărut o problemă de conexiune. Încercați din nou.',
      unknown: 'A apărut o eroare neașteptată.',
      invalid_credentials: 'Email sau parolă incorecte.',
      otp_invalid: 'Cod invalid sau expirat. Încearcă din nou sau cere un cod nou.',
      otp_resend_failed: 'Codul nu a putut fi retrimis: adresa este deja verificată sau incorectă.',
    },
    common: {
      loading: 'Se încarcă…',
      loadingPatients: 'Se încarcă pacienții…',
      back: 'Înapoi',
      retry: 'Reîncearcă',
      load_error: 'Datele nu au putut fi încărcate.',
      confirm: 'Confirmă',
      cancel: 'Anulează',
      close: 'Închide',
    },
    maintenance: {
      title: 'Contul meu este în mentenanță',
      section_title: 'Secțiune temporar indisponibilă',
      default_message: 'Lucrăm la îmbunătățirea aplicației. Vă rugăm să reveniți în curând.',
      period: 'Perioada estimată: {{start}} – {{end}}',
      retry: 'Verifică din nou',
      back_home: 'Înapoi la Acasă',
      scheduled_label: 'Mentenanță programată',
      active_label: 'Mentenanță în curs',
      sections: {
        all: 'Toată aplicația',
        medical_record: 'Dosar medical',
        appointments: 'Programări',
      },
    },
    nav: {
      account: 'Contul meu',
      menu: 'Meniu',
      home: 'Acasă',
      newAppointment: 'Programare nouă',
      appointments: 'Programările mele',
      results: 'Rezultate',
      attachedAccounts: 'Conturi login',
      patients: 'Lista pacienți',
      logout: 'Deconectare',
      /** Tooltip on the inert menu entries while the account has no patient yet. */
      locked: 'Disponibil după adăugarea contului de pacient',
    },
    accounts: {
      title: 'Conturi de login atașate',
      about_title: 'Despre conturile atașate',
      about_text:
        'Atașează conturile tale Google, Facebook și Apple ca să te poți autentifica mai ușor. Poți folosi oricare dintre conturile atașate pentru a te loga pe același profil.',
      attached_title: 'Conturi atașate',
      empty: 'Nu ai conturi sociale atașate.',
      attach_title: 'Atașează cont nou',
      attach: 'Atașează cont {{provider}}',
      detach: 'Detașează',
      detach_title: 'Detașezi contul?',
      detach_confirm: 'Sigur vrei să detașezi contul {{provider}}?',
      attached_ok: 'Contul {{provider}} a fost atașat cu succes.',
      detached_ok: 'Contul a fost detașat cu succes.',
      error_generic: 'A apărut o eroare. Încearcă din nou.',
      error_ineligible: 'Acest cont social nu poate fi atașat (este deja cont principal sau atașat altundeva).',
      error_provider: 'Autentificarea cu furnizorul a eșuat.',
      error_ticket: 'Sesiunea de atașare a expirat. Încearcă din nou.',
    },
    dashboard: {
      greeting: 'Bună, {{name}}!',
      subtitle: 'Iată un rezumat al contului tău medical.',
      upcoming_hint: 'programări viitoare',
      results_hint: 'rezultate disponibile',
      next_appointment: 'Următoarea programare',
    },
    patients: {
      you: 'Tu',
      dependent: 'Persoană atașată',
      switch: 'Schimbă pacientul',
      /** Sidebar placeholder while the account has no patient yet. */
      none: 'Niciun pacient',
      none_hint: 'Adaugă contul de pacient',
      list: {
        cta: 'Lista pacienți',
        title: 'Lista pacienți',
        subtitle: 'Conturile de pacient asociate contului tău.',
        empty: 'Nu există niciun pacient pe acest cont.',
        born_on: 'Data nașterii: {{date}}',
        primary_title: 'Pacientul principal',
        attached_to_title: 'Conturi la care ești atașat',
        attached_to_hint:
          'Aceste conturi pot vedea istoricul tău medical și pot face programări în numele tău.',
        attached_none: 'Nu ești atașat la niciun alt cont.',
        attached_refreshing: 'Se actualizează…',
        dependents_title: 'Pacienți atașați la contul meu',
        dependents_empty: 'Nu ai niciun pacient atașat la contul tău.',
        detach: 'Șterge asocierea',
        detach_dependent: 'Elimină',
        detaching: 'Se șterge…',
        detach_title: 'Ștergi asocierea?',
        detach_confirm: 'Te dezatașezi de la contul {{account}}?',
        detach_dependent_title: 'Dezatașezi pacientul?',
        detach_dependent_confirm: 'Dezatașezi pacientul {{name}} de la contul tău?',
        detach_success: 'Asocierea a fost ștearsă.',
        detach_outcome: {
          invalid: 'Contul nu se află în lista de asocieri ale pacientului.',
          notImplemented:
            'Ștergerea asocierii nu este încă activă pe server. Încearcă mai târziu.',
          error: 'A apărut o eroare. Încearcă din nou.',
        },
      },
      attachCode: {
        cta: 'Cod atașare',
        hint: 'Permite altei persoane să-ți gestioneze contul.',
        title: 'Codul tău de atașare',
        code_label: 'Codul tău',
        copy: 'Copiază codul',
        copied: 'Copiat!',
        refreshing: 'Se verifică codul curent…',
        unavailable:
          'Codul de atașare nu este disponibil momentan. Încearcă din nou mai târziu sau adresează-te recepției.',
        rules: {
          single_person:
            'Acest cod poate fi transmis și folosit de o singură persoană, pentru a-ți atașa contul în aplicația ei Gral Medical.',
          access:
            'Odată atașat, persoana respectivă va putea vedea întregul tău istoric medical și va putea face programări în numele tău.',
          single_use:
            'Codul poate fi folosit o singură dată și rămâne valabil până în momentul utilizării.',
          rotates:
            'După utilizare, codul se schimbă automat. Dacă vrei să oferi acces și unei alte persoane, revino aici și preia codul nou.',
        },
        caution:
          'Transmite codul doar persoanelor în care ai încredere: acesta oferă acces complet la datele tale medicale.',
      },
      add: {
        cta: 'Adaugă pacient',
        title: 'Adaugă un pacient',
        subtitle: 'Atașează un membru de familie la contul tău.',
        /** Same form, first patient of a fresh account (nothing else works until it exists). */
        first_title: 'Adaugă contul de pacient',
        first_subtitle:
          'Introdu CNP-ul și codul de activare primit la recepție. Programările și rezultatele devin disponibile după ce contul de pacient este adăugat.',
        cnp: 'CNP',
        cnp_placeholder: '1234567890123',
        cnp_invalid: 'CNP-ul trebuie să conțină exact 13 cifre.',
        cnp_checksum: 'CNP-ul introdus nu este valid (cifra de control nu corespunde).',
        code: 'Cod de activare',
        code_placeholder: 'Codul primit la recepție',
        code_required: 'Codul de activare este obligatoriu.',
        hint: 'Codul de activare se obține de la recepția oricărei clinici Gral Medical.',
        submit: 'Adaugă pacientul',
        attached_at: 'Pacientul este atașat și la: {{emails}}',
        outcome: {
          registered: 'Pacientul a fost înregistrat cu succes.',
          attached: 'Pacientul a fost atașat contului tău.',
          invalidCode: 'Codul de activare este invalid.',
          invalidSsn: 'CNP-ul introdus nu este valid sau nu corespunde.',
          notDefined:
            'Pacientul nu are încă un cod de activare generat. Adresați-vă recepției.',
          existingAccount: 'Acest pacient are deja un cont propriu.',
          alreadyAttached: 'Pacientul este deja atașat contului tău.',
          alreadyUsed: 'Codul de activare a fost deja folosit.',
          attachedTooMany: 'Pacientul este atașat la numărul maxim de conturi.',
          duplicateSsn: 'CNP înregistrat de mai multe ori. Contactați recepția.',
          unknown: 'A apărut o eroare. Încercați din nou.',
        },
      },
    },
    appointments: {
      title: 'Programările mele',
      subtitle: 'Programările tale viitoare și efectuate.',
      upcoming: 'Viitoare',
      past: 'Efectuate',
      upcoming_one: 'Viitoare',
      past_one: 'Efectuată',
      consultation: 'Consultație',
      date_label: 'Data consultației',
      location_label: 'Locație',
      empty_upcoming: 'Nu ai programări viitoare.',
      empty_past: 'Nu ai programări efectuate.',
      empty_hint: 'Programările apar aici imediat ce sunt înregistrate.',
      load_error: 'Nu am putut încărca programările.',
    },
    booking: {
      new_cta: 'Programare nouă',
      title: 'Programare nouă',
      subtitle: 'Alege clinica, specialitatea și medicul, apoi ora dorită.',
      confirm_subtitle: 'Verifică detaliile și confirmă programarea.',

      city: 'Oraș',
      city_placeholder: 'Alege orașul',
      location: 'Locație',
      location_placeholder: 'Alege locația',
      specialty: 'Specialitate',
      specialty_placeholder: 'Alege specialitatea',
      service: 'Serviciu',
      service_placeholder: 'Alege serviciul',
      doctor: 'Medic',
      doctor_placeholder: 'Alege medicul',
      restart: 'Reia căutarea',

      mode_title: 'Cum dorești să programezi?',
      mode_first: 'Primul loc disponibil',
      mode_first_hint: 'Găsim automat cea mai apropiată oră liberă.',
      mode_manual: 'Selectează ziua și ora',
      mode_manual_hint: 'Alegi tu data și intervalul orar.',

      search_first: 'Caută primul loc disponibil',
      searching_first: 'Căutăm primul loc disponibil…',
      first_found: 'Primul loc disponibil',

      manual_need_doctor: 'Alege medicul și serviciul pentru a vedea programul disponibil.',
      loading_slots: 'Se încarcă programul…',
      no_slots_month: 'Nu există ore disponibile în această lună.',
      next_month: 'Luna următoare',
      pick_time: 'Alege ora',

      continue: 'Continuă',
      confirm_title: 'Detalii programare',
      confirm: 'Confirmă programarea',
      confirm_error: 'Nu am putut finaliza programarea. Încercați din nou.',
      patient: 'Pacient',
      note: 'Informații suplimentare (opțional)',
      note_placeholder: 'Adaugă detalii pentru medic…',

      summary_doctor: 'Medic',
      summary_specialty: 'Specialitate',
      summary_service: 'Serviciu',
      summary_datetime: 'Data și ora',
      summary_location: 'Locație',
      summary_price: 'Preț',
      price_unspecified: 'Preț nespecificat',

      success_title: 'Programare confirmată!',
      go_appointments: 'Vezi programările',
    },
    results: {
      title: 'Rezultatele mele',
      subtitle: 'Rezultatele analizelor și consultațiilor tale.',
      untitled: 'Rezultat medical',
      final: 'Finalizat',
      in_progress: 'În progres',
      documents_summary: '{{available}} din {{total}} documente disponibile',
      open: 'Deschide documentul',
      open_n: 'Deschide documentul {{n}}',
      download_error: 'Nu am putut deschide documentul. Încercați din nou.',
      empty: 'Nu ai rezultate disponibile.',
      empty_hint: 'Rezultatele apar aici după finalizarea investigațiilor.',
      load_error: 'Nu am putut încărca rezultatele.',
      back_to_list: 'Înapoi la rezultate',
      not_found: 'Rezultatul nu a fost găsit.',
      detail_specialty: 'Specialitate',
      detail_date: 'Data consultației',
      detail_location: 'Locație',
      detail_address: 'Adresă',
      documents_title: 'Documente',
      no_documents: 'Nu există documente pentru această investigație.',
      see_all: 'Vezi toate ({{count}})',
      see_less: 'Vezi mai puține',
    },
  },
} as const;
